import elementTextFilter from '../../../../modules/Gull/Framework/elementTextFilter.js';

const edit = {

	init() {

		var elementTextFilterElement = document.querySelector('[data-element-text-filter-input]');
		elementTextFilter.init(elementTextFilterElement);

	}
};

export default edit;
